import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';

import NoRoute from './pages/NoRouteFound';
import NewLandingPage from './pages/new-landing-page';
import PerformanceEngg from './pages/performance-engg';

export function Router() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<NewLandingPage />} />
        <Route path="/test-intelligence" element={<NewLandingPage />} />
        <Route path="/performance-engineering" element={<PerformanceEngg />} />
        <Route path="*" element={<NoRoute />} />
      </Routes>
    </BrowserRouter >
  );
}

export default Router;